import { mapGetters } from "vuex";
import UpdateAditionalInsurance from "@/utils/updateAditionalInsurance";

export default {
  computed: {
    ...mapGetters({
      loadDetailsView: "load/getChosenLoadDetailsView",
    }),
    loadInsuranceFee() {
      const savedFee = Number(this.loadDetailsView?.cargocare_insurance_selling_rate_amount);
      if (Number.isFinite(savedFee) && savedFee > 0) {
        return savedFee;
      }
      return UpdateAditionalInsurance(this.loadDetailsView?.cargo_value_for_insurance);
    },
  },
};
